/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
export { array, Dataset, zip } from './dataset';
export { CSVDataset } from './datasets/csv_dataset';
export { TextLineDataset } from './datasets/text_line_dataset';
export { csv, func, generator, microphone, webcam } from './readers';
export { FileDataSource } from './sources/file_data_source';
export { URLDataSource } from './sources/url_data_source';
export { version as version_data } from './version';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@tensorflow/tfjs-data/dist/index.js
// module id = 582
// module chunks = 0